//
//
//
//
//

import {
  BADGE_VARIANTS,
  BADGE_VARIANT_DEFAULT,
  BADGE_VARIANT_RED,
  BADGE_VARIANT_GREEN,
  BADGE_VARIANT_BLUE,
  BADGE_VARIANT_YELLOW,
} from '../../utils/constants'
export default {
  props: {
    variant: {
      type: String,
      default: BADGE_VARIANT_DEFAULT,
      validator: (x) => Object.keys(BADGE_VARIANTS).includes(x),
    },
  },
  computed: {
    badgeClass() {
      const cls = [
        'tw-inline',
        'tw-gap-1',
        'md:tw-gap-1.5',
        'tw-ring-1',
        'tw-rounded',
        'tw-leading-tight',
        'tw-align-text-top',
        'tw-px-1',
        'tw-py-0.5',
      ]

      switch (this.variant) {
        case BADGE_VARIANT_DEFAULT:
        default:
          cls.push(['tw-ring-gray-200', 'tw-text-gray-700', 'tw-bg-gray-50'])
          break
        case BADGE_VARIANT_RED:
          cls.push([
            'tw-ring-red-600',
            'tw-text-white',
            'tw-antialiased',
            'tw-bg-red-500',
          ])
          break
        case BADGE_VARIANT_GREEN:
          cls.push([
            'tw-ring-green-700',
            'tw-text-white',
            'tw-antialiased',
            'tw-bg-green',
          ])
          break
        case BADGE_VARIANT_BLUE:
          cls.push(['tw-ring-blue-100', 'tw-text-blue-700', 'tw-bg-blue-50'])
          break
        case BADGE_VARIANT_YELLOW:
          cls.push(['tw-ring-yellow-200', 'tw-text-yellow', 'tw-bg-yellow-100'])
          break
      }

      return cls
    },
  },
  methods: {
    handleClick(e) {
      if (!this.disabled) {
        this.$emit('click', e)
      }
    },
  },
}
